import * as React from 'react';

import classnames from 'classnames';
import _ from 'lodash';

import { color } from '@coursera/coursera-ui';
import { SvgSmallChevronDown, SvgSmallChevronUp } from '@coursera/coursera-ui/svg';

import type { SortBy } from 'bundles/enterprise-admin-messages/types';
import { SortByDirection } from 'bundles/enterprise-admin-messages/types';
import type { AttributeSelections } from 'bundles/enterprise-admin-users/types';

import 'css!./__styles__/SortableTableHeader';

type Props = {
  label: React.ReactNode;
  column: AttributeSelections;
  onSortChange: (column: AttributeSelections) => void;
  sortBy: SortBy[];
};

class SortableTableHeader extends React.Component<Props> {
  handleSortChange = () => {
    const { column, onSortChange } = this.props;
    onSortChange(column);
  };

  getDirection = (): SortByDirection | undefined => {
    const { sortBy, column } = this.props;
    const thisColumnSort = sortBy.find((sortItem) => sortItem.column === column);
    if (thisColumnSort) return thisColumnSort.direction;
  };

  renderSvgButton = () => {
    const direction = this.getDirection();
    const size = 12;
    const svgColor = color.white;
    return direction === SortByDirection.asc ? (
      <SvgSmallChevronUp color={svgColor} size={size} />
    ) : (
      <SvgSmallChevronDown color={svgColor} size={size} />
    );
  };

  render() {
    const { label, column } = this.props;
    const e2eLabel = `sort-${_.kebabCase(column)}`;
    return (
      <div className="rc-SortableTableHeader">
        <button
          className={classnames('c-sortButton horizontal-box align-items-vertical-center', {
            withDirection: !!this.getDirection(),
          })}
          type="button"
          onClick={this.handleSortChange}
          data-e2e={e2eLabel}
          data-testid={e2eLabel}
        >
          <span className="c-buttonLabel m-r-1s">{label}</span>
          {this.renderSvgButton()}
        </button>
      </div>
    );
  }
}

export default SortableTableHeader;
